<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group has-label">
          <label>Zeitraum</label>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="Bis"
            start-placeholder="Anfangsdatum"
            end-placeholder="Enddatum"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
            @change="fetchTableData"
            :picker-options="{ firstDayOfWeek: 1 }"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6" v-if="productCategories.length > 0">
        <div class="form-group has-label">
          <label>Product Kategorie</label>
          <multiselect v-model="selectedProductCategories"
            :multiple="true"
            :options="productCategories"
            track-by="id"
            label="name"
            @input="fetchTableData"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <product-select
          v-model="product"
          @input="fetchTableData"
        />
      </div>
    </div>
    <div style="overflow-x: auto; margin-top: 0.75em;">
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>Produkt</th>
          <th>Kategorie</th>
          <th class="text-center">Menge</th>
          <th class="text-center">&Oslash; VK (n) / Stk.</th>
          <th class="text-center">EK (n) / Stk.</th>
          <th class="text-center">&sum; VK (n) </th>
          <th class="text-center">&sum; EK (n) </th>
          <th class="text-center"><strong>DB</strong></th>
        </tr>
      </thead>
      <transition name="el-fade-in-linear">
        <tbody v-if="! loading">
          <tr is="RevenueRow" v-for="stockRotation in stockRotations" :key="stockRotation.id"
            :stock-rotation="stockRotation"
            :get-db="getDb" :get-umsatz="getUmsatz" :get-preis="getPreis"
          />
        </tbody>
      </transition>
      <tfoot>
        <tr>
          <td colspan="5">
            <strong>Summe:</strong>
          </td>
          <td class="text-right">
            <strong>{{ totalUmsatz | priceFromCentZeroEuro }}</strong>
          </td>
          <td class="text-right">
            <strong>{{ totalPrice | priceFromCentZeroEuro }}</strong>
          </td>
          <td class="text-right">
            <strong>{{ totalDb | priceFromCentZeroEuro }}</strong>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  </div>
</template>

<script>
import { DatePicker } from 'element-ui'
import moment from 'moment'
import RevenueRow from './revenue-row'
import { groupNewestSuppliers } from 'src/util/helpers'
import ProductSelect from 'src/components/product-select'

export default {
  components: {
    RevenueRow,
    ProductSelect,
    [DatePicker.name]: DatePicker
  },
  data () {
    return {
      dateRange: [
        moment().startOf('month').format('YYYY-MM-DD'),
        moment().endOf('month').format('YYYY-MM-DD')
      ],
      stockRotations: [],
      productCategories: [],
      selectedProductCategories: [],
      product: null,
      loading: true
    }
  },
  computed: {
    totalDb () {
      return this.stockRotations.reduce((total, stockRotation) => {
        const db = this.getDb(stockRotation)
        return total + db
      }, 0)
    },
    totalUmsatz () {
      return this.stockRotations.reduce((total, stockRotation) => {
        const umsatz = this.getUmsatz(stockRotation)
        return total + umsatz
      }, 0)
    },
    totalPrice () {
      return this.stockRotations.reduce((total, stockRotation) => {
        const preis = this.getPreis(stockRotation)
        return total + preis
      }, 0)
    }
  },
  methods: {
    fetchTableData () {
      this.loading = true

      const dateRangeFilter = this.dateRange ? encodeURIComponent(this.dateRange) : ''
      const productCategories = this.selectedProductCategories.length ? encodeURIComponent(this.selectedProductCategories.map(pc => pc.id)) : ''
      const product = this.product ? this.product.id : ''

      this.$http.get(`/revenue?date_range=${dateRangeFilter}&product_categories=${productCategories}&product=${product}`).then(({ data }) => {
        this.stockRotations = data.map(stockRotation => {
          const productSuppliers = groupNewestSuppliers(stockRotation.product.suppliers)
          const cheapestSupplier = productSuppliers.length ? productSuppliers[0].price : ''
          return { ...stockRotation, cheapestSupplier }
        })
        this.loading = false
      })
    },
    getDb (stockRotation) {
      const einkaufsPreis = stockRotation.cheapestSupplier || stockRotation.product.standard_price
      const umsatz = this.getUmsatz(stockRotation)
      if (umsatz && einkaufsPreis) {
        return umsatz - (einkaufsPreis * stockRotation.quantity_sold)
      }
      return 0
    },
    getUmsatz (stockRotation) {
      return +stockRotation.sum_price_sold
    },
    getPreis (stockRotation) {
      const price = stockRotation.cheapestSupplier || stockRotation.product.standard_price
      return price * stockRotation.quantity_sold
    }
  },
  created () {
    this.fetchTableData()
    this.$http.get('/product_categories').then(({ data }) => { this.productCategories = data })
  }
}
</script>
